(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('AiAssistantMonitoringController', AiAssistantMonitoringController);

    AiAssistantMonitoringController.$inject = ['AiAssistantMonitoring', 'AlertService', '$window', '$document', '$scope', 'Principal'];

    function AiAssistantMonitoringController(AiAssistantMonitoring, AlertService, $window, $document, $scope, Principal) {
        var vm = this;
        var CONVERSATION_PAGE_SIZE = 40;
        var DATA_SCOPE_LABELS = {
            billingMonthlyStats: 'Facturation mensuelle',
            billingDetails: 'Détail facturation',
            waterMonthlyStats: 'Consommation mensuelle',
            waterDetails: 'Détail consommation',
            contractHistory: 'Historique contrat',
            meterChanges: 'Changements compteur'
        };

        vm.filters = {
            feedbackStatus: 'ALL',
            userLogin: '',
            organisationName: '',
            contractReference: '',
            areaName: '',
            dateFrom: null,
            dateTo: null,
            hasExecutedActions: 'ALL',
            hasErrors: 'ALL'
        };
        vm.filteredConversations = [];
        vm.visibleConversations = [];
        vm.filteredTotalTokens = 0;
        vm.loadingOverview = false;
        vm.loadingDetail = false;
        vm.overview = {
            totalConversations: 0,
            satisfiedConversations: 0,
            unsatisfiedConversations: 0,
            noFeedbackConversations: 0,
            distinctUsers: 0,
            distinctOrganisations: 0,
            totalTokens: 0,
            conversations: []
        };
        vm.detail = null;
        vm.selectedConversation = null;
        vm.isSuperAdmin = false;

        vm.loadOverview = loadOverview;
        vm.applyFeedbackFilter = applyFeedbackFilter;
        vm.loadMoreConversations = loadMoreConversations;
        vm.selectConversation = selectConversation;
        vm.getFeedbackStatusClass = getFeedbackStatusClass;
        vm.isConversationSelected = isConversationSelected;
        vm.toggleJson = toggleJson;
        vm.copyConversationFlowJson = copyConversationFlowJson;
        vm.copyConversationApiExchangeJson = copyConversationApiExchangeJson;
        vm.getDataScopeLabels = getDataScopeLabels;
        vm.hasVisibleConversationContent = hasVisibleConversationContent;
        vm.copyFeedbackMessage = null;

        Principal.identity().then(function(account) {
            vm.isSuperAdmin = !!(account && account.authorities && account.authorities.indexOf('ROLE_SUPER_ADMIN') !== -1);
        });
        loadOverview();

        function loadOverview() {
            vm.loadingOverview = true;
            AiAssistantMonitoring.getOverview().then(function(response) {
                vm.overview = response.data || vm.overview;
                applyFeedbackFilter();
            }).catch(function(error) {
                AlertService.error(resolveErrorMessage(error, 'Impossible de charger la supervision de l\'assistant IA.'));
            }).finally(function() {
                vm.loadingOverview = false;
            });
        }

        function applyFeedbackFilter() {
            var conversations = angular.copy(vm.overview.conversations || []);
            if (vm.filters.feedbackStatus !== 'ALL') {
                conversations = conversations.filter(function(conversation) {
                    return conversation.feedbackStatus === vm.filters.feedbackStatus;
                });
            }
            if ((vm.filters.userLogin || '').trim()) {
                conversations = conversations.filter(function(conversation) {
                    return ((conversation.userLogin || '').toLowerCase()).indexOf(vm.filters.userLogin.toLowerCase()) !== -1;
                });
            }
            if ((vm.filters.organisationName || '').trim()) {
                conversations = conversations.filter(function(conversation) {
                    return ((conversation.organisationName || '').toLowerCase()).indexOf(vm.filters.organisationName.toLowerCase()) !== -1;
                });
            }
            if ((vm.filters.contractReference || '').trim()) {
                conversations = conversations.filter(function(conversation) {
                    return ((conversation.contractReference || '').toLowerCase()).indexOf(vm.filters.contractReference.toLowerCase()) !== -1;
                });
            }
            if ((vm.filters.areaName || '').trim()) {
                conversations = conversations.filter(function(conversation) {
                    return ((conversation.areaName || '').toLowerCase()).indexOf(vm.filters.areaName.toLowerCase()) !== -1;
                });
            }
            if (vm.filters.hasExecutedActions !== 'ALL') {
                conversations = conversations.filter(function(conversation) {
                    return String(!!conversation.hasExecutedActions) === vm.filters.hasExecutedActions;
                });
            }
            if (vm.filters.hasErrors !== 'ALL') {
                conversations = conversations.filter(function(conversation) {
                    return String(!!conversation.hasErrors) === vm.filters.hasErrors;
                });
            }
            if (vm.filters.dateFrom) {
                conversations = conversations.filter(function(conversation) {
                    return toDate(conversation.lastActivityAt) >= startOfDay(vm.filters.dateFrom);
                });
            }
            if (vm.filters.dateTo) {
                conversations = conversations.filter(function(conversation) {
                    return toDate(conversation.lastActivityAt) <= endOfDay(vm.filters.dateTo);
                });
            }
            vm.filteredConversations = conversations;
            vm.visibleConversations = vm.filteredConversations.slice(0, CONVERSATION_PAGE_SIZE);
            vm.filteredTotalTokens = vm.filteredConversations.reduce(function(total, conversation) {
                return total + (conversation && conversation.totalTokens ? conversation.totalTokens : 0);
            }, 0);
        }

        function loadMoreConversations() {
            var nextCount;
            if (!vm.filteredConversations || vm.visibleConversations.length >= vm.filteredConversations.length) {
                return;
            }
            nextCount = Math.min(vm.filteredConversations.length, vm.visibleConversations.length + CONVERSATION_PAGE_SIZE);
            vm.visibleConversations = vm.filteredConversations.slice(0, nextCount);
        }

        function selectConversation(conversation) {
            if (!conversation || !conversation.conversationId) {
                return;
            }
            vm.selectedConversation = conversation;
            vm.loadingDetail = true;
            AiAssistantMonitoring.getDetail(conversation.conversationId).then(function(response) {
                vm.detail = response.data;
                vm.copyFeedbackMessage = null;
            }).catch(function(error) {
                AlertService.error(resolveErrorMessage(error, 'Impossible de charger le detail de la conversation IA.'));
            }).finally(function() {
                vm.loadingDetail = false;
            });
        }

        function getFeedbackStatusClass(feedbackStatus) {
            if (feedbackStatus === 'OK') {
                return 'label label-success';
            }
            if (feedbackStatus === 'NON') {
                return 'label label-danger';
            }
            return 'label label-default';
        }

        function isConversationSelected(conversation) {
            return vm.selectedConversation && conversation && vm.selectedConversation.conversationId === conversation.conversationId;
        }

        function toggleJson(event) {
            if (!event) {
                return;
            }
            event.showJson = !event.showJson;
        }

        function copyConversationFlowJson() {
            var serializedFlow;
            if (!vm.detail || !vm.detail.events || !vm.detail.events.length) {
                return;
            }
            serializedFlow = angular.toJson(buildConversationFlowExport(vm.detail), true);
            copyTextToClipboard(serializedFlow);
        }

        function copyConversationApiExchangeJson() {
            var serializedExchange;
            if (!vm.detail || !vm.detail.events || !vm.detail.events.length) {
                return;
            }
            serializedExchange = angular.toJson(buildConversationApiExchangeExport(vm.detail), true);
            copyTextToClipboard(serializedExchange, 'Echange JSON copie.');
        }

        function getDataScopeLabels(selectedDataScopes) {
            if (!selectedDataScopes || !selectedDataScopes.length) {
                return ['Aucune catégorie'];
            }
            return selectedDataScopes.map(function(scope) {
                return DATA_SCOPE_LABELS[scope] || scope;
            });
        }

        // La vue admin simplifiée ne doit afficher que les échanges compréhensibles par l'utilisateur.
        function hasVisibleConversationContent(event) {
            return !!(event
                && (event.requestTotalTokens
                || event.sentMessage
                || event.receivedMessage
                || (event.clarificationQuestions && event.clarificationQuestions.length)
                || (event.actionSummaries && event.actionSummaries.length)
                || event.hasAction));
        }

        function buildConversationFlowExport(detail) {
            return {
                conversationId: detail.conversationId,
                conversationDisplayId: detail.conversationDisplayId,
                contextType: detail.contextType,
                entityId: detail.entityId,
                contextLabel: detail.contextLabel,
                contractReference: detail.contractReference,
                areaName: detail.areaName,
                userLogin: detail.userLogin,
                organisationName: detail.organisationName,
                feedbackStatus: detail.feedbackStatus,
                feedbackComment: detail.feedbackComment,
                totalTokens: detail.totalTokens,
                hasExecutedActions: !!detail.hasExecutedActions,
                hasErrors: !!detail.hasErrors,
                apiExchangeHistory: (detail.events || []).map(function(event) {
                    var eventJson = parseFormattedJson(event.formattedJson) || {};
                    return {
                        archivedAt: event.archivedAt,
                        stage: event.stage,
                        stageLabel: event.stageLabel,
                        flowLabel: event.flowLabel,
                        direction: resolveExchangeDirection(event.stage),
                        requestTotalTokens: event.requestTotalTokens,
                        feedbackComment: event.feedbackComment,
                        provider: eventJson.apiExchange ? eventJson.apiExchange.provider : null,
                        request: eventJson.apiExchange ? eventJson.apiExchange.request : null,
                        response: eventJson.apiExchange ? eventJson.apiExchange.response : null,
                        summary: eventJson.summary || {
                            sentMessage: event.sentMessage,
                            receivedMessage: event.receivedMessage,
                            clarificationQuestions: event.clarificationQuestions,
                            actionSummaries: event.actionSummaries
                        }
                    };
                })
            };
        }

        function buildConversationApiExchangeExport(detail) {
            return {
                conversationId: detail.conversationId,
                conversationDisplayId: detail.conversationDisplayId,
                totalTokens: detail.totalTokens,
                feedbackComment: detail.feedbackComment,
                apiExchangeHistory: (detail.events || []).map(function(event) {
                    var eventJson = parseFormattedJson(event.formattedJson) || {};
                    return {
                        archivedAt: event.archivedAt,
                        stage: event.stage,
                        stageLabel: event.stageLabel,
                        flowLabel: event.flowLabel,
                        direction: resolveExchangeDirection(event.stage),
                        requestTotalTokens: event.requestTotalTokens,
                        feedbackComment: event.feedbackComment,
                        apiRequest: eventJson.apiExchange ? eventJson.apiExchange.request : null,
                        apiResponse: eventJson.apiExchange ? eventJson.apiExchange.response : null
                    };
                }).filter(function(item) {
                    return item.apiRequest || item.apiResponse;
                })
            };
        }

        function resolveExchangeDirection(stage) {
            var normalizedStage = (stage || '').toLowerCase();
            if (normalizedStage.indexOf('planner') !== -1 || normalizedStage.indexOf('chat-request') !== -1) {
                return 'WAMASYS_TO_AI_API';
            }
            if (normalizedStage.indexOf('chat-response') !== -1) {
                return 'AI_API_TO_WAMASYS';
            }
            if (normalizedStage.indexOf('error') !== -1) {
                return 'ERROR';
            }
            return 'LOCAL_EVENT';
        }

        function parseFormattedJson(formattedJson) {
            if (!formattedJson) {
                return null;
            }
            try {
                return angular.fromJson(formattedJson);
            } catch (error) {
                return {
                    raw: formattedJson
                };
            }
        }

        function copyTextToClipboard(value, successMessage) {
            if ($window.navigator && $window.navigator.clipboard && $window.navigator.clipboard.writeText) {
                $window.navigator.clipboard.writeText(value).then(function() {
                    setCopyFeedbackMessage(successMessage || 'Flux JSON copie.');
                }).catch(function() {
                    fallbackCopyText(value, successMessage);
                });
                return;
            }
            fallbackCopyText(value, successMessage);
        }

        function fallbackCopyText(value, successMessage) {
            var textarea = $document[0].createElement('textarea');
            textarea.value = value;
            textarea.setAttribute('readonly', 'readonly');
            textarea.style.position = 'fixed';
            textarea.style.left = '-9999px';
            $document[0].body.appendChild(textarea);
            textarea.select();
            try {
                $document[0].execCommand('copy');
                setCopyFeedbackMessage(successMessage || 'Flux JSON copie.');
            } catch (error) {
                AlertService.error('Impossible de copier le flux JSON.');
            } finally {
                $document[0].body.removeChild(textarea);
            }
        }

        function setCopyFeedbackMessage(message) {
            vm.copyFeedbackMessage = message;
            $scope.$evalAsync();
        }

        function resolveErrorMessage(error, fallback) {
            return error && error.data && error.data.message ? error.data.message : fallback;
        }

        function toDate(value) {
            var date = new Date(value);
            return isNaN(date.getTime()) ? new Date(0) : date;
        }

        function startOfDay(value) {
            var date = new Date(value);
            date.setHours(0, 0, 0, 0);
            return date;
        }

        function endOfDay(value) {
            var date = new Date(value);
            date.setHours(23, 59, 59, 999);
            return date;
        }
    }
})();
